import React from 'react'

import * as Styled from './Info.styled'

const Info = () => {
  return (
    <Styled.Info>
      <Styled.Text>
        Компоновщик URL может создать ссылку с&nbsp;динамическими параметрами&nbsp;&mdash;
        переменными, которые передают дополнительную информацию из&nbsp;систем интернет-рекламы.
        Их&nbsp;используют, чтобы не&nbsp;создавать метки для каждого ключевого слова, типа кампании
        и&nbsp;т.&nbsp;п.
      </Styled.Text>
      <Styled.Example>
        <Styled.TitleWrapper>
          <h5>Например</h5>
        </Styled.TitleWrapper>
        <p>
          Если в&nbsp;поле utm_term добавить параметр {'{keyword}'}, в&nbsp;момент клика Яндекс
          Директ сам заменит {'{keyword}'} на&nbsp;ключевую фразу
        </p>
      </Styled.Example>
    </Styled.Info>
  )
}

export default Info
